import { LazyAutocompleteField } from '@occc/ui-design-system';
import { FormInputProps } from '@occc-app/design-system';
import { ExternalIdentityVerificationAttributeFragment } from '@occc/graphql';
import { useGetExternalIdentityVerificationAttributesLazy } from '@occc-app/dataAccessLayer/externalIdentityVerificationAttributes/queries';

interface ExternalIdentityVerificationAttributeSelectProps {
  name: string;
  label?: string;
  inputProps?: FormInputProps;
}

const mapQueryResponseToRawArray = (
  response: ReturnType<typeof useGetExternalIdentityVerificationAttributesLazy>['response'],
): ExternalIdentityVerificationAttributeFragment[] => response.data || [];

const mapRawItemToAutocompleteOption = (item: ExternalIdentityVerificationAttributeFragment) => ({
  label: item.name,
  value: item.handle,
  _raw: item,
});

export const ExternalIdentityVerificationAttributeSelect = ({
  name,
  label,
  inputProps,
}: ExternalIdentityVerificationAttributeSelectProps) => {
  return (
    <LazyAutocompleteField
      name={name}
      label={label ?? 'Select community'}
      inputProps={inputProps}
      useLazyQuery={useGetExternalIdentityVerificationAttributesLazy}
      mapQueryResponseToRawArray={mapQueryResponseToRawArray}
      mapRawResponseItemToAutocompleteOption={mapRawItemToAutocompleteOption}
    />
  );
};
